import React, { useState } from 'react';
import { Select, Modal } from 'antd';
import { useQuery, useMutation } from '@common/hooks';
import {
  PerformWorksShiftAction,
  WorksShiftRejectionReasons,
  WorksShiftRejectionReasonsResponse,
} from '@scheduling/graphql';
import { createMessage } from 'works/legacy/lib/message-helper';
import { TextAreaEmojiPicker, Form, Text } from '@common/components';
export function ShiftCancelModal({
  worksShiftId,
  visible,
  setVisible,
}: {
  worksShiftId: string | undefined;
  visible: boolean;
  setVisible: (value: boolean) => void;
}) {
  const [form] = Form.useForm();
  const [note, setNote] = useState('');

  const { data: cancelledReasons } =
    useQuery<WorksShiftRejectionReasonsResponse>(WorksShiftRejectionReasons, {
      variables: {
        reasonType: 'cancellation',
      },
    });

  const [cancelWorksShift, { loading: cancelLoading }] = useMutation(
    PerformWorksShiftAction,
    {
      onCompleted: (data) => {
        if (data?.performWorksShiftAction?.worksShift) {
          createMessage(
            'success',
            'Shift successfully canceled. Please be sure to remove this shift from the schedule.'
          );
        }
      },
      onError: () => {
        createMessage(
          'error',
          'Shift could not be canceled. Please try again or contact your hiring partner.'
        );
      },
      refetchQueries: [
        'ShiftGapDetails',
        'PaginatedShiftGapOpenings',
        'PaginatedShiftGapOpeningsCount',
      ],
    }
  );

  return (
    <>
      <Modal
        open={visible}
        onCancel={() => setVisible(false)}
        cancelText="No, Go Back"
        okText="Yes, Cancel"
        onOk={form.submit}
        title="Are you sure you want to cancel this shift?"
        okButtonProps={{ loading: cancelLoading }}
      >
        <Text>This action cannot be undone.</Text>
        <Form
          form={form}
          layout="vertical"
          className="shift-cancel-form"
          onFinish={(values) => {
            cancelWorksShift({
              variables: {
                worksShiftId: worksShiftId || '',
                input: {
                  action: 'manager_cancel',
                  rejectionReasonCode: values.cancelledReason,
                  managerNote: note,
                },
              },
            });
            setVisible(false);
          }}
        >
          <Form.Item
            label="Reason"
            name="cancelledReason"
            rules={[
              { required: true, message: 'Please choose a cancel reason' },
            ]}
          >
            <Select placeholder="Select a reason" style={{ width: '100%' }}>
              {cancelledReasons?.worksShiftRejectionReasons.map((reason) => (
                <Select.Option key={reason.id} value={reason.code}>
                  {reason.displayName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Notes" name="note">
            <TextAreaEmojiPicker rows={4} onChange={setNote} value={note} />
          </Form.Item>
        </Form>
      </Modal>
      <style jsx>
        {`
          :global(.shift-cancel-form) {
            padding-top: 16px;
          }
        `}
      </style>
    </>
  );
}
